import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const FilterContentContainer = styled(Stack)`
    width: 296px;
`;
